// extracted by mini-css-extract-plugin
export default {"background":"styles_background__z+1SR","image":"styles_image__-a-We","container":"styles_container__MRcaS","wrapper":"styles_wrapper__3RYr-"};